import { Routes, Route } from 'react-router-dom'
import { lazy, Suspense } from 'react'
import Layout from './components/Layout'
import ProtectedRoute from './components/ProtectedRoute'
import Home from './pages/Home'
import Verify from './pages/Verify'
import Login from './pages/Login'

// 懒加载页面
const Profile = lazy(() => import('./pages/Profile'))
const OrderHistory = lazy(() => import('./pages/OrderHistory'))
const BrandShop = lazy(() => import('./pages/BrandShop'))
const ProductDetail = lazy(() => import('./pages/ProductDetail'))
const OrderDetail = lazy(() => import('./pages/OrderDetail'))
const MyRewards = lazy(() => import('./pages/MyRewards'))
const MyFavorites = lazy(() => import('./pages/MyFavorites'))
const ReportFake = lazy(() => import('./pages/ReportFake'))
const MySpace = lazy(() => import('./pages/MySpace'))
const SpaceDetail = lazy(() => import('./pages/SpaceDetail'))
const SpaceSquare = lazy(() => import('./pages/SpaceSquare'))
const WorldHall = lazy(() => import('./pages/WorldHall'))
const PlayerCard = lazy(() => import('./pages/PlayerCard'))
const Feed = lazy(() => import('./pages/Feed'))

// 加载中组件
const LoadingFallback = () => (
  <div className="flex items-center justify-center py-20">
    <div className="flex flex-col items-center gap-4">
      <div className="w-8 h-8 border-4 border-cyber-neon border-t-transparent rounded-full animate-spin" />
      <div className="text-gray-400">加载中...</div>
    </div>
  </div>
)

function App() {
  return (
    <Routes>
      {/* 独立页面 - 不需要Layout */}
      <Route path="/login" element={<Login />} />

      <Route path="/" element={<Layout />}>
        {/* 公开页面 */}
        <Route index element={<Home />} />
        <Route path="verify" element={<Verify />} />
        <Route path="shop/:brandId" element={
          <Suspense fallback={<LoadingFallback />}>
            <BrandShop />
          </Suspense>
        } />
        <Route path="product/:id" element={
          <Suspense fallback={<LoadingFallback />}>
            <ProductDetail />
          </Suspense>
        } />
        <Route path="report" element={
          <Suspense fallback={<LoadingFallback />}>
            <ReportFake />
          </Suspense>
        } />

        {/* 需要登录的页面 */}
        <Route path="orders" element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingFallback />}>
              <OrderHistory />
            </Suspense>
          </ProtectedRoute>
        } />
        <Route path="orders/:orderNo" element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingFallback />}>
              <OrderDetail />
            </Suspense>
          </ProtectedRoute>
        } />
        <Route path="rewards" element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingFallback />}>
              <MyRewards />
            </Suspense>
          </ProtectedRoute>
        } />
        <Route path="favorites" element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingFallback />}>
              <MyFavorites />
            </Suspense>
          </ProtectedRoute>
        } />
        <Route path="profile" element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingFallback />}>
              <Profile />
            </Suspense>
          </ProtectedRoute>
        } />

        {/* 数字展馆（Showcase） */}
        <Route path="space/my" element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingFallback />}>
              <MySpace />
            </Suspense>
          </ProtectedRoute>
        } />
        <Route path="space-square" element={
          <Suspense fallback={<LoadingFallback />}>
            <SpaceSquare />
          </Suspense>
        } />
        <Route path="world" element={
          <Suspense fallback={<LoadingFallback />}>
            <WorldHall />
          </Suspense>
        } />
        <Route path="player/:userId" element={
          <Suspense fallback={<LoadingFallback />}>
            <PlayerCard />
          </Suspense>
        } />
        <Route path="feed" element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingFallback />}>
              <Feed />
            </Suspense>
          </ProtectedRoute>
        } />
        <Route path="space/:id" element={
          <Suspense fallback={<LoadingFallback />}>
            <SpaceDetail />
          </Suspense>
        } />
      </Route>
    </Routes>
  )
}

export default App
